export default [
  {
    label: 'アライアンス名',
    key: 'search_agent',
  },
  {
    label: 'マネージャID',
    key: 'search_admin_name',
  },
]
